<section>
  <app-datatable
    *ngIf="isDataTableReady"
    [columns]="columns"
    [dataUrl]="dataUrl"
    [defaultSort]="defaultSort"
    [scrollV]="false"
    [scrollH]="true"
    [preventInitialLoad]="true"
    [disableFiltering]="false"
    data-automation-id="active-prior-auth-list-insurer_202127112055"
    emptyMessage="There are no active Prior Authorization Requests."
    [multiSelect]="isWorkloadAdministrator"
    [rowClass]="getRowClass"
    [exportFileName]="'My Organization\'s PARs Queue'"
    [bulkEditActionTmpl]="bulkActions"
    (rowSelected)="onRowSelected()"
  ></app-datatable>

  <ng-template #idTemplate let-row="row" let-value="value">
    <a
      class="mat-button-link"
      data-automation-id="active-prior-auth-list-insurer_202127112059"
      tabindex="0"
      [routerLink]="[AppUrls.priorAuthorization.details(row.priorAuthorizationId)]"
    >
      <span class="sr-only">Navigate to Prior Auth</span>
      {{ value | entityFormatter: priorAuthTypeCode }}
    </a>
  </ng-template>

  <ng-template #bulkActions let-selected="selected">
    <button
      mat-stroked-button
      color="primary"
      data-automation-id="active-prior-auth-list-insurer_202127112103"
      (click)="openAssignPriorAuthModal(selected)"
      *ngIf="isWorkloadAdministrator"
    >
      <span>Assign</span>
    </button>
    {{ numRowsSelected }} item(s) selected
  </ng-template>

  <ng-template #injuryDateTemplate let-row="row" let-value="value">
    {{ row.dateOfInjuryDisplay }}
  </ng-template>
</section>
